module.exports = __webpack_public_path__ + "img/cmmi.ec90c6ab.png";